/**
 * Doc Library
 */
$(document).on("ready", function () {
  if (!$("#library").length) return;

  var dropzone, errors;

  // Modal
  $("#upload").on("click", function (e) {
    e.preventDefault();
    $("#uploadOl").toggleClass("active");
    $("#uploadOl").off("click");
    $("#uploadOl").on("click", function (e) {
      if (e.target == this) {
        $("#uploadOl").toggleClass("active");
      }
    });
  });

  function displayErrors(errors) {
    if (!errors.length) return false;

    let txt = '<p class="error">';
    $.each(errors, (index, msg) => {
      txt += `${msg}<br/>`;
    });
    txt += "</p>";

    $("#errors").append(txt);
    return true;
  }

  function clearErrors() {
    errors = [];
    $("#uploadForm input, #uploadForm select").removeClass("error");
    $("#errors").html("");
  }

  const $uploadForm = $("form#uploadForm");
  $uploadForm.on("submit", (event) => {
    event.preventDefault();
  });

  const filenameCharacterLimit = 70;
  const characterLimitMsg = `File names, including file extension, must be less than ${filenameCharacterLimit} characters.`;

  $uploadForm.dropzone({
    acceptedFiles: '.pdf,.doc,.docx,.jpg,.jpeg',
    url: $uploadForm.attr("action"),
    paramName: "filename",
    createImageThumbnails: false,
    clickable: "#uploadBtn",
    autoProcessQueue: false,
    maxFilesize: 2,//MB
    maxFiles:1,
    accept: function(file, done) {
      if (file.name.length > 70) {
        done("File names, including file extension, must be less than 70 characters.");
      }
      else {
        $('#theUpload .error').remove();
        done();
      }
    },
    init:function(){
      var myDropzone;
      myDropzone = dropzone = this;
      myDropzone.on("addedfile", function(file) {
        $('#filename').val(file.name);
      });
      var submitButton = document.querySelector("#btnUpload");
      submitButton.addEventListener("click", function(e) {
        e.preventDefault();
        var errors=[];
        $('#uploadForm input, #uploadForm select').removeClass('error');
        $('#errors').html('');
        if(myDropzone.files.length==0){
          errors.push('Please select a file to upload.');
        }
        if($('#filename').val()==''){
          $('#filename').addClass('error');
          errors.push('Please enter a file name.');
        }
        if($('#filetype').val()==''){
          $('#filename').addClass('error');
          errors.push('Please select a type.');
        }
        //console.log(errors);
        if(errors.length==0) {
          myDropzone.processQueue();
        }else{
          var errs='<p class="error">';
          for(e in errors){
            errs+=errors[e]+'<br/>';
          }
          errs+='</p>';
          $('#errors').append(errs);
        }
      });
      myDropzone.on('error',function(file,errorMsg){
        //console.log(file);
        //console.log(errorMsg);

        var errors=[];
        errors.push(errorMsg);

        var errs='<p class="error">';
        for(var e in errors){
          errs+=errors[e]+'<br/>';
        }
        errs+='</p>';
        $('#errors').html(errs);
        myDropzone.removeFile(file);
        $('#filename').val('');
      });
      myDropzone.on("addedfile", function(file) {
      });
      myDropzone.on("complete", function(file) {
        //console.log(file);
        if(!file.accepted) return;
        myDropzone.removeFile(file);
        $('#filename').val('');
        $('#uploadOl').toggleClass('active');
        window.location.reload();
      });
      myDropzone.on('maxfilesexceeded', function(file) {
        myDropzone.removeFile(file);
        myDropzone.removeAllFiles();
        myDropzone.addFile(file);
      });
    },
  });

  $(document).on("click", "#btnUpload", function (e) {
    e.preventDefault();
    e.stopPropagation();
    clearErrors();

    // Validation
    if (!dropzone.files.length) {
      errors.push("Please select a file to upload.");
    }
    if (!$("#filename").val()) {
      $("#filename").addClass("error");
      errors.push("Please enter a file name.");
    }
    if (!$("#filetype").val()) {
      $("#filename").addClass("error");
      errors.push("Please select a type.");
    }
    if (dropzone.files.length && dropzone.files[0].name.length >= filenameCharacterLimit) {
      errors.push(characterLimitMsg);
    }

    // Errors
    const hasErrors = displayErrors(errors);
    if (hasErrors) return;

    // Upload
    $("#btnUpload").text("Loading...");
    dropzone.processQueue();
  });

  $("a.delete").on("click", function (e) {
    e.preventDefault();

    const id = $(this).attr("id");
    const $tr = $(this).parents("tr");

    $(this).find("img").attr("src", `${basePath}/wp-content/plugins/mega-pathway/assets/images/icons/ajax-loader.gif`);
    $(this).addClass("loading");

    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action: "fw_delete_document",
        id: id,
      },
      success: function (data) {
        $tr.fadeOut();
      },
      error: function (xhr, desc, err) {
        console.log(xhr);
        console.log("Details0: " + desc + "\nError:" + err);
      },
    });
  });

});
